import { type PropsWithChildren, createContext, Component } from 'react';
import { doesWindowExist } from '../../utils/dom/dom.utils';

export type ConstructContextState = Readonly<{
	highlightContent: boolean;
	setHighlightContent: (highlightContent: boolean) => void;
	constructHost: string;
}>;

const initialState: ConstructContextState = {
	highlightContent: false,
	setHighlightContent: () => {},
	constructHost: '//npntest-construct.build.com'
};

export const ConstructContext = createContext<ConstructContextState>(initialState);

export class ConstructProvider extends Component<PropsWithChildren, ConstructContextState> {
	readonly state: ConstructContextState = {
		...initialState,
		setHighlightContent: (highlightContent: boolean) => {
			this.setState(() => ({ highlightContent }));
		}
	};

	componentDidMount() {
		/**
		 * When the component mounts (client side only) we check to see if there
		 * is a construct host defined (should be populated from config server).
		 * If so we update the state of constructHost in the context.
		 */
		if (doesWindowExist() && window.BCOM?.constructHost) {
			this.setState(() => ({ constructHost: window.BCOM.constructHost }));
		}
	}

	render() {
		return <ConstructContext.Provider value={this.state}>{this.props.children}</ConstructContext.Provider>;
	}
}
